import React from 'react';

export const AboutMe = () => {
  return (
    <div id="about" className="w-full h-screen bg-primary text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-accent">About</p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-2xl font-bold ">
            <p>
              Hi. I&apos;m Christoph,
              <br /> nice to meet you.{' '}
            </p>
          </div>
          <div>
            <p className="tracking-wider">
              👋 Supply chain and digital transformation professional with 7+ years of international experience across FMCG, semiconductor, automotive,
              and consulting environments. Experienced in end-to-end supply chain management, order-to-cash, capacity planning and strategic
              process optimization. Skilled in leveraging AI and automated solutions to improve operational efficiency and decision-making.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
